<!-- Базовый нижний футер форм с действиями и списком незаполненных полей. -->
<template>
  <div class="base-form-footer">
    <div
      v-if="isMissingFieldsExpanded && hasMissingFields"
      class="base-form-footer__missing-list"
    >
      <button
        v-for="group in missingFieldGroups"
        :key="group.key"
        type="button"
        class="base-form-footer__missing-item"
        @click="$emit('select-missing-field', group.sectionRef)"
      >
        <span class="base-form-footer__missing-item-title">
          {{ group.title }}
        </span>
        <span class="base-form-footer__missing-item-text">
          {{ group.items.join(", ") }}
        </span>
      </button>
    </div>

    <div class="base-form-footer__bar">
      <slot name="info"></slot>

      <div class="base-form-footer__actions">
        <component
          v-for="action in actions"
          :key="action.key"
          :is="actionComponent(action)"
          type="button"
          :form="action.form"
          :disabled="action.disabled"
          @click="$emit('action', action.key)"
        >
          {{ action.label }}
        </component>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseFormFooter",

  props: {
    actions: {
      type: Array,
      required: true,
    },
    missingFieldGroups: {
      type: Array,
      default: () => [],
    },
    isMissingFieldsExpanded: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["action", "select-missing-field"],

  computed: {
    hasMissingFields() {
      return this.missingFieldGroups.length > 0;
    },
  },

  methods: {
    actionComponent(action) {
      return action.variant === "primary"
        ? "base-primary-button"
        : "base-button";
    },
  },
};
</script>

<style scoped>
.base-form-footer {
  position: fixed;
  bottom: 0;
  left: var(--sidebar-width);
  right: 0;
  z-index: 20;
  background: #fff;
  border-top: 1px solid var(--color-border, #e5e7eb);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  transition: left 0.3s ease;
}

.base-form-footer__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 20px;
  background: #fff;
}

.base-form-footer__actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-left: auto;
}

.base-form-footer__missing-list {
  display: grid;
  gap: 8px;
  max-height: 220px;
  overflow-y: auto;
  padding: 12px 20px;
  border-bottom: 1px solid var(--color-border, #e5e7eb);
  background: #fffbeb;
}

.base-form-footer__missing-item {
  display: grid;
  gap: 3px;
  width: 100%;
  padding: 9px 10px;
  border: 1px solid #fee2e2;
  border-radius: 8px;
  background: #fff7ed;
  color: #7f1d1d;
  cursor: pointer;
  text-align: left;
}

.base-form-footer__missing-item:hover {
  border-color: #fca5a5;
  background: #fff1f2;
}

.base-form-footer__missing-item-title {
  font-size: 13px;
  font-weight: 700;
}

.base-form-footer__missing-item-text {
  color: #92400e;
  font-size: 12px;
}

@media (max-width: 760px) {
  .base-form-footer {
    left: 0;
  }

  .base-form-footer__bar {
    align-items: center;
    gap: 10px;
    padding: 8px 10px calc(8px + env(safe-area-inset-bottom));
  }

  .base-form-footer__actions {
    flex: 1 1 auto;
    justify-content: flex-end;
    gap: 8px;
    min-width: 0;
    margin-left: 0;
    overflow-x: auto;
    scrollbar-width: none;
  }

  .base-form-footer__actions::-webkit-scrollbar {
    display: none;
  }

  .base-form-footer__actions > * {
    flex: 1 0 max(86px, calc((100vw - 154px) / 2));
    min-width: 0;
    white-space: nowrap;
  }

  .base-form-footer__missing-list {
    max-height: 36dvh;
    padding: 10px;
    overscroll-behavior: contain;
  }

  .base-form-footer__missing-item {
    padding: 8px 9px;
  }

  .base-form-footer__missing-item-text {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>
